(function(window) {
   'use strict';
   
   window.TSC = window.TSC || {};
   window.TSC.windowWrapper = (function() {
      return {
         getLocationHref: function() {
            return window.location.href;
         },
         getLocation: function() {
            return window.location;
         },
         open: function(url, features) {
            if (features) {
               window.open(url, features);
            } else {
               window.open(url);
            }
         }
      };
   }());
}(this));
